import { useInfiniteQuery } from '@tanstack/react-query';
import { productApi } from '../services/productApi';
import { useSearchParams } from 'react-router-dom';
import { useMemo } from 'react';

const PAGE_SIZE = 20;

export function useCatalog(shopId) {
  const [searchParams] = useSearchParams();
  const filters = useMemo(
    () => ({ ...Object.fromEntries(searchParams.entries()), ...(shopId ? { shopId } : {}) }),
    [searchParams, shopId]
  );

  const query = useInfiniteQuery({
    queryKey: ['catalog', filters],
    queryFn: ({ pageParam = 1 }) => {
      return productApi.search({
        ...filters,
        page: pageParam,
        limit: PAGE_SIZE,
      });
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) => {
      const total = lastPage.total;
      const nextPage = allPages.length + 1;
      // если все страницы загружены — возвращаем undefined
      return allPages.length * PAGE_SIZE < total ? nextPage : undefined;
    },
    staleTime: 5 * 60 * 1000, // кэш на 5 минут
    keepPreviousData: !shopId,
  });

  const products = useMemo(
    () => query.data?.pages.flatMap((page) => page.products) ?? [],
    [query.data]
  );

  return {
    products,
    total: query.data?.pages[0]?.total ?? 0,
    refetch: query.refetch,
    isLoading: query.isLoading,
    isFetchingNextPage: query.isFetchingNextPage,
    hasNextPage: query.hasNextPage,
    fetchNextPage: query.fetchNextPage,
    isError: query.isError,
    error: query.error,
  };
}
